module.exports = __webpack_public_path__ + "img/网易新闻_02.f86ee4d5.jpg";